import { render, staticRenderFns } from "./CampaignBuilderLineActionEditAwards.vue?vue&type=template&id=c365bc6a&"
import script from "./CampaignBuilderLineActionEditAwards.vue?vue&type=script&lang=js&"
export * from "./CampaignBuilderLineActionEditAwards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports